import { ProductHealthInsurance } from "@meditect/medibase-api-client";

import { apiClient } from "@/features/api/apiClient";

import fetchLocalData from "../../utils/fetchLocalData";
import { Slice } from "../boundStore";

export type ProductHealthInsuranceSlice = {
  error: boolean;
  fetchProductHealthInsurances: () => Promise<void>;
  isFetching: boolean;
  productHealthInsurances: ProductHealthInsurance[];

  resetData: () => void;
  updatedAt: Date | undefined;
};

const fetchProductHealthInsurances = async (): Promise<ProductHealthInsurance[]> => {
  const data = [];
  const size = 200;
  const { items, totalPages } = await apiClient.productHealthInsurance.getAll(0, size);

  if (totalPages === 1) {
    return items;
  }
  data.push(...items);

  for (let page = 1; page < totalPages; page++) {
    const { items: nextItems } = await apiClient.productHealthInsurance.getAll(page, size);
    data.push(...nextItems);
  }

  return data.flat();
};

export const createProductHealthInsuranceSlice: Slice<ProductHealthInsuranceSlice> = (set, get) => ({
  error: false,
  // Fetcher
  fetchProductHealthInsurances: async () => {
    await fetchLocalData(set, get, "productHealthInsurance.productHealthInsurances", fetchProductHealthInsurances);
  },
  isFetching: false,
  // State
  productHealthInsurances: [],
  updatedAt: undefined,

  resetData: () => {
    set(({ productHealthInsurance: state }) => {
      state.productHealthInsurances = [];
      state.updatedAt = undefined;
    });
  },
});
